<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="后台角色管理"
                name="1"
				key="1"
                :link="`/system/role/list`"
            ></el-tab-pane>
			<el-tab-pane
			    v-if="$utils.have('/suduRole/pageList')"
			    label="经营平台角色管理"
			    name="2"
				key="2"
			    :link="`/system/fb/role/list`"
			></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
		
    },
    data() {
        return {
            activeName: this.name,
        };
    },
	
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
		
    },
};
</script>

<style lang="scss" scoped>

</style>